




























import { UserModule } from '@/store/modules/user';
import TableComp from '@/components/Common/TableComp.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { previewFile } from '@/utils/function_utils';

@Component({
  name: 'studentCourseApplyList',
  components: {
    TableComp,
  }
})
export default class extends Vue {
  @Prop({ default: () => [] }) public tableData!: any[];

  get agentId() {
    return Number(UserModule.fkAgentId);
  }

  get mediaAndAttached() {
    return (fileList: any) => {
      if (fileList && fileList.length > 0) {
        return fileList.map((item: any) => item.typeKey).join(',');
      }
      return '';
    }
  }

  public handlePreview(file: any) {
    previewFile({
      fileKey: file.fileKey,
      filePath: file.filePath,
      fileNameOrc: file.fileNameOrc,
    });
  }

  public getImageUrl(index: number) {
    try {
      return require('@/assets/image/common/status' + (index + 1) + '.png');
    } catch(err) {
      return '';
    }
  }

  public handleAdd() {
    const stuid = this.$route.params.id + '';
    this.$router.push({name: 'studentApplicationForm', params: { stuid }, query: { agid: this.agentId + '' }});
  }
}
